var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgSpinner = function SvgSpinner(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M18 9A9 9 0 1 1 0 9a9 9 0 0 1 18 0ZM2.7 9a6.3 6.3 0 1 0 12.6 0A6.3 6.3 0 0 0 2.7 9Z",
    fill: "currentcolor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.65 9c.746 0 1.36-.608 1.249-1.345A9 9 0 0 0 10.345.101C9.608-.01 9 .604 9 1.35c0 .746.611 1.336 1.34 1.494a6.299 6.299 0 0 1 4.816 4.816c.159.729.748 1.34 1.494 1.34Z",
    fill: "currentcolor"
  })));
};

export default SvgSpinner;